<script>
    import ConfirmModal from "./ConfirmModal.svelte";
    import TokenDetails from "../snippets/TokenDetails.svelte";
    import {eventBridge, portalConfiguration} from "../../stores.js";

    let {
        showConfirm = $bindable(false),
        token,
        tokenDeletion,
        ...rest
    } = $props();

    const handleDeleteConfirm = () => {
        $eventBridge.dispatchEvent('cs:removeTokenFromCache', {
            tokenId: token.fingerprint
        });
        tokenDeletion?.();
        showConfirm = false;
    };

    const handleDeleteCancel = () => {
        showConfirm = false;
    };
</script>

<ConfirmModal
    {...rest}
    bind:showConfirm
    cancelLabel="Abbrechen"
    title="Zertifikat löschen"
    helpUrl={`${$portalConfiguration.help ?? ''}/einrichtung-von-bea/organisatorische-und-technische-voraussetzungen/loeschung-software-token`}
    cancel={handleDeleteCancel}
    confirm={handleDeleteConfirm}
    scrollable
    size="xl"
>
    Möchten Sie das nachfolgende Software-Token wirklich löschen?
    {#if showConfirm}
        <TokenDetails {token} />
    {/if}
</ConfirmModal>
